module.exports = __webpack_public_path__ + "img/example_glass_03.dc36d939.png";